// extracted by mini-css-extract-plugin
export var ourPartners = "our-partners-module--our-partners--tlj-z";
export var partner = "our-partners-module--partner--MJkkE";
export var partnerLogo = "our-partners-module--partner-logo--YmRtS";